import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar",
  "use": "calendar-usage",
  "viewBox": "0 0 18 20",
  "content": "<symbol viewBox=\"0 0 18 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"calendar\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 2H15V0H13V2H5V0H3V2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 18H2V7H16V18Z\" />\n<path d=\"M9 9H4V14H9V9Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol